export default __webpack_public_path__ + "static/media/ponte.e1b8c335.png";